<!-- 加工单列表 -->
<template>
    <div id="transOrders" class="business-content-main trans-order">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="false"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button v-if="permission.addTransOut" size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="gotoTransEdit(3)">{{
                    permission.addTransOut
                }}</el-button>
                <el-button v-if="permission.printTrans" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{ permission.printTrans }}</el-button>
                <el-button v-if="permission.transScanOut" title="扫码出仓" size="small" class="search-btn" type="warning" @click="scanTransOut()">{{
                    permission.transScanOut
                }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">加工商</div>
                <el-select
                    class="search-item"
                    size="small"
                    v-model="searchData.CusId"
                    remote
                    filterable
                    allow-create
                    placeholder="请输入加工商名称"
                    :remote-method="searchSupplier"
                    v-select-scroll-more="searchSupplierLoad"
                >
                    <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusId"> </el-option>
                </el-select>
                <div class="search-name">加工单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode" placeholder="加工单号"></el-input>
                <div class="search-name">调出仓库</div>
                <el-select v-model="searchData.OutWarehouseId" :loading="loading" class="search-item" size="small" filterable clearable remote>
                    <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                        ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                    >
                </el-select>
                <div class="search-name">回货仓库</div>
                <el-select v-model="searchData.InWarehouseId" :loading="loading" class="search-item" size="small" filterable clearable remote>
                    <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                        ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                    >
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                style="width: 100%"
                @cell-dblclick="handleDBClick"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column width="180px" label="加工单号">
                    <template slot-scope="scope">
                        <el-badge :value="'打印' + scope.row.PrintedCount + '次'" class="mark" type="danger" v-if="scope.row.PrintedCount > 0">
                            {{ scope.row.PTOCode }}
                        </el-badge>
                        {{ scope.row.PrintedCount > 0 ? '' : scope.row.PTOCode }}
                    </template>
                </el-table-column>
                <el-table-column prop="CusName" width="160px" show-overflow-tooltip label="加工商"> </el-table-column>
                <el-table-column prop="AllCostMoney" width="120px" show-overflow-tooltip label="加工费用"> </el-table-column>
                <el-table-column show-overflow-tooltip label="调出仓库" width="120px">
                    <template slot-scope="scope">{{ scope.row.OutWarehouseCode }} <span v-if="scope.row.OutWarehouseType == 1" style="color: #8492a6">(前置仓)</span></template>
                </el-table-column>
                <el-table-column prop="DeliverShipAmount" width="100px" show-overflow-tooltip label="调出运费"> </el-table-column>
                <el-table-column show-overflow-tooltip label="回货仓库" width="120px"
                    ><template slot-scope="scope"
                        >{{ scope.row.InWarehouseCode }} <span v-if="scope.row.InWarehouseType == 1" style="color: #8492a6">(前置仓)</span></template
                    ></el-table-column
                >
                <el-table-column prop="ReturnShipAmount" width="100px" show-overflow-tooltip label="回货运费"> </el-table-column>
                <el-table-column width="100px" show-overflow-tooltip label="合计总额">
                    <template slot-scope="scope">{{ (scope.row.AllCostMoney + scope.row.DeliverShipAmount + scope.row.ReturnShipAmount).toFixed(2) }} </template>
                </el-table-column>
                <el-table-column prop="StateName" width="120px" show-overflow-tooltip label="状态"> </el-table-column>
                <el-table-column show-overflow-tooltip prop="Remark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Creator" label="创建人"></el-table-column>
                <el-table-column show-overflow-tooltip width="110px" prop="CreateTime" label="创建时间"></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.editTrans && scope.row.IsCanUpdate" title="编辑" size="mini" type="text" @click="gotoTransEdit(2, scope.row)"
                                >编辑</el-button
                            >
                            <el-button v-if="permission.submitTrans && scope.row.IsCanSubmit" title="提交" size="mini" type="text" @click="submit(scope.row)">提交</el-button>
                            <el-button
                                v-if="permission.updateOrderAfterSubmit && scope.row.IsCanUpdateOrderAfterSubmit"
                                title="修改"
                                size="mini"
                                type="text"
                                @click="gotoTransEdit(7, scope.row)"
                                >修改</el-button
                            >
                            <el-button
                                v-if="permission.transOut && scope.row.IsCanOutWarehouse && scope.row.OutWarehouseType == 0"
                                title="出仓"
                                size="mini"
                                type="text"
                                @click="warehouseOut(scope.row.PTOId)"
                                >出仓</el-button
                            >
                            <el-button
                                v-if="permission.transScanOut && scope.row.IsCanOutWarehouse && scope.row.OutWarehouseType == 0"
                                title="扫码出仓"
                                size="mini"
                                type="text"
                                @click="scanTransOut(scope.row.PTOId)"
                                >{{ permission.transScanOut }}</el-button
                            >
                             <el-button
                                v-if="permission.backEdit && scope.row.IsCanBackEdit"
                                title="回货编辑"
                                size="mini"
                                type="text"
                                @click="gotoTransEdit(4, scope.row)"
                                >回货编辑</el-button
                            >
                            <el-button
                                v-if="permission.transIn && scope.row.IsCanInWarehouse && scope.row.InWarehouseType == 0"
                                title="入仓"
                                size="mini"
                                type="text"
                                @click="warehouseIn(scope.row.PTOId)"
                                >入仓</el-button
                            >
                            <el-button v-if="permission.cancelTrans && scope.row.IsCanCancel" style="color:orange;" title="撤销" size="mini" type="text" @click="cancel(scope.row)">撤销</el-button>
                            <el-button v-if="permission.delTrans && scope.row.IsCanDelete"  style="color:red;" title="删除" size="mini" type="text" @click="del(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.Page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.Limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <!--   出仓     -->
        <el-dialog :close-on-click-modal="false" title="加工单出仓" :visible.sync="outVisible" width="1000px">
            <div v-if="outVisible">
                <warehouseOut :PTOId="ptoId" @closeDialog="closeOutDialog"></warehouseOut>
            </div>
        </el-dialog>
        <!--   入仓     -->
        <el-dialog :close-on-click-modal="false" title="加工单入仓" :visible.sync="inVisible" width="1000px">
            <div v-if="inVisible">
                <warehouseIn :PTOId="ptoId" @closeDialog="closeInDialog"></warehouseIn>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="加工单打印" :visible.sync="dialogVisible" width="870px">
            <div class="dialog-content" v-if="dialogVisible">
                <printContent @closeDialog="closeDialog" :printIds="idList"></printContent>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import warehouseOut from '@/components/business/goods/processTransWarehouseOut';
import warehouseIn from '@/components/business/goods/processTransWarehouseIn';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        warehouseOut,
        warehouseIn
    },
    data() {
        return {
            ptoId: '',
            inVisible: false,
            outVisible: false,
            dialogVisible: false,
            multipleSelection: null,
            dataReadonly: false,
            idList: [],
            WarehouseIdEdit: '',
            loading: false,
            WarehouseList: [],
            positionList: [],
            searchData: {
                OrderCode: '',
                CusId: '',
                InWarehouseId: '',
                OutWarehouseId: '',
                Page: 1,
                Limit: this.commonPageSize
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            // 用于供应商列表，分页搜索
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    mounted() {
        
        this.permission = this.$util.getPermission('processTrans');
        this.getWarehouse();
        this.getTableData();
        let that = this;
        that.searchSupplier();
        //实际上数据库还没这个模板类型
            that.$util.getPrintComponents(10).then(data => {
                if (data) {
                    Vue.component('printContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printContent', () => import('@/components/printModels/printProcessTransOrder'));
                }
            });        
    },
    methods: {
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        // 提交
        submit(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要提交该加工单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpTransferOrder/SubmitEntpProcessTransOrder?PTOId=${row.PTOId}`,
                        })
                        .then(() => {
                            that.$util.successMsg('提交加工单成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        // 删除
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该加工单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpTransferOrder/DeleteEntpProcessTransOrder?PTOId=${row.PTOId}`,
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        // 出仓
        warehouseOut(id) {
            if (id) {
                this.ptoId = id;
                this.outVisible = true;
            }
        },
        closeOutDialog(edit) {
            this.outVisible = false;
            this.ptoId = '';
            if (edit) this.getTableData();
        },
        // 入仓
        warehouseIn(id) {
            if (id) {
                this.ptoId = id;
                this.inVisible = true;
            }
        },
        closeInDialog(edit) {
            this.inVisible = false;
            this.ptoId = '';
            if (edit) this.getTableData();
        },
        cancel(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要撤销该加工单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpTransferOrder/CancelEntpProcessTransOrder?PTOId=${row.PTOId}`,
                        })
                        .then(() => {
                            that.$util.successMsg('撤销成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        gotoTransEdit(type, row) {
            let PTOId = row ? row.PTOId : '';
            let from = this.$route.meta.from;
            if (from == 'inventory') {
                this.$router.push(`/inventoryManage/processTrans/edit?type=${type}&PTOId=${PTOId}`);
            } else {
                this.$router.push(`/inventoryManage/processTrans/edit?type=${type}&PTOId=${PTOId}`);
            }
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetEntpProcessTransOrderList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.WarehouseList = data;
            });
        },
        resetSearch() {
            this.searchData = {
                OrderCode: '',
                CusId: '',
                InWarehouseId: '',
                OutWarehouseId: '',
                Page: 1,
                Limit: this.commonPageSize
            };
        },
        handleSearch() {
            this.searchData.Page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                this.gotoTransEdit(1, event);
            }
        },
        closeDialog() {
            this.dialogVisible = false;
            this.getTableData();
        },
        // 打印
        print() {
            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择一张加工单打印');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能选择一张加工单打印');
                return;
            }
            if (this.multipleSelection[0].StateName == '已撤消') {
                this.$util.warningMsg('不能打印已撤消的加工单');
                return;
            }
            if (this.multipleSelection[0].IsCanSubmit) {
                this.$util.warningMsg('不能打印未提交的加工单');
                return;
            }
            if (this.multipleSelection[0].OutWarehouseType == 1) {
                this.$util.warningMsg('不能打印调出仓库为前置仓的加工单');
                return;
            }
            this.dialogVisible = true;
        },
        handleSelectionChange(val) {
            let idList = [];
            this.multipleSelection = val;
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].PTOId);
            }
            this.idList = idList;
        },
        scanTransOut(ptOId) {
            if (ptOId) this.$router.push(`/inventoryManage/processTrans/transScanOut?stype=1&PTOId=${ptOId}`);
            else this.$router.push(`/inventoryManage/processTrans/transScanOut?stype=0`);
        }
    }
};
</script>
<style lang="less">
.trans-order {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
